import React, { useState } from 'react'
import { Button } from 'primereact/button'
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog'
import { configs } from '@configs'
import { useSiteContext } from '@contexts/MkSiteContext'
import { useLDFlagsWithDevOverrides } from '@hooks/useLaunchDarkly'
import { serverUrl } from '@utils/MkEnv'
import 'primeicons/primeicons.css'

export interface MkThemeSwitcherProps {}

export const MkThemeSwitcher: React.FC<MkThemeSwitcherProps> = () => {
  const { themeBrand, updateContext, saveSelectedBrand } = useSiteContext()
  const [dropdownVisible, setDropdownVisible] = useState(false)

  // Read feature flags (with safe fallback if LD unavailable)
  const flags = useLDFlagsWithDevOverrides<Record<string, any>>()
  const showMakoMenu: boolean = flags?.switchShowMakoMenu ?? true

  const { brands } = configs.mk

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible)
  }

  const handleThemeChange = (theme: string) => {
    if (updateContext) {
      saveSelectedBrand(theme)
    }
    setDropdownVisible(false)
  }

  const isCurrentTheme = (theme: string) => themeBrand === theme

  if (!showMakoMenu) return null

  return (
    <div className="fixed right-2 top-1/2 transform -translate-y-1/2 z-50">
      <Button
        icon="pi pi-cog"
        className="p-button-rounded"
        aria-label="Toggle theme switcher"
        onClick={toggleDropdown}
        style={{
          backgroundColor: 'green',
          color: 'white',
          width: '30px',
          height: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
      {dropdownVisible && (
        <div className="absolute right-10 w-16 top-1/2 transform -translate-y-1/2 bg-white border border-gray-300 rounded p-2 z-50 shadow-md">
          <ConfirmDialog />
          <Button
            onClick={() =>
              confirmDialog({
                message: `Are you sure you want to POST ${serverUrl}/mkapi/v1/update/clearAndUpdateAll?`,
                header: 'Confirm Update',
                icon: 'pi pi-exclamation-triangle',
                accept: () => fetch(`${serverUrl}/mkapi/v1/update/clearAndUpdateAll`, { method: 'POST' }),
              })
            }
            className="block mb-1 font-normal text-black">
            update
          </Button>
          <hr className="border-blue-500 pb-2" />
          {brands.map((theme) => (
            <Button
              key={theme}
              onClick={() => handleThemeChange(theme)}
              className={`block mb-1 text-black ${isCurrentTheme(theme) ? 'font-bold' : 'font-normal'}`}>
              {theme}
            </Button>
          ))}
        </div>
      )}
    </div>
  )
}
